import React, { FC, forwardRef } from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';

import { SurveyAnswerIntelligence } from '../store/api/apiTypes';

import { translateSurveyAnswerIntelligence } from '../helpers/i18n';

const SurveyIntelligenceSelect: FC<SelectProps<SurveyAnswerIntelligence>> = forwardRef((props, ref: any) => (
    <Select
        ref={ref}
        filterOption={false}
        style={{ width: '100%' }}
        allowClear
        {...props}
    >
        {
            (Object.keys(SurveyAnswerIntelligence) as Array<keyof typeof SurveyAnswerIntelligence>).map((key) => (
                <Select.Option value={key} key={key}>
                    {translateSurveyAnswerIntelligence(SurveyAnswerIntelligence[key])}
                </Select.Option>
            ))
        }
    </Select>
));

export default SurveyIntelligenceSelect;
